import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import ReactDOM from 'react-dom';
import { Box, Backdrop, CircularProgress, Typography } from '@mui/material';
import { CircularProgressWithLabel } from '../../components/CircularProgressWithLabel';

const LoadingBackdrop = props => {
  const { intl, className, open, maxLoadingTime, style } = props;
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let timer;
    if (open && maxLoadingTime) {
      setProgress(0);
      timer = setInterval(() => {
        setProgress(prevProgress => {
          if (prevProgress >= 99) {
            return 99;
          }
          return prevProgress + 99 / (maxLoadingTime * 10); // in seconds
        });
      }, 100);
    } else {
      setProgress(0);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [open]);

  return ReactDOM.createPortal(
    <Backdrop className={className} open={open} style={{ zIndex: 1400, ...style }}>
      {progress ? (
        <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <CircularProgressWithLabel value={progress} size={56} fontSize={14} />
          {progress === 99 && (
            <Typography color="primary" style={{ fontSize: 15, marginTop: 12 }}>
              {intl.formatMessage({ id: 'still-loading-please-do-not-close-the-page' })}
            </Typography>
          )}
        </Box>
      ) : (
        <CircularProgress color="primary" />
      )}
    </Backdrop>,
    document.body
  );
};

export default injectIntl(LoadingBackdrop);
